<template>
    <div>
        <div v-for="(item, index) in uploadInfo" :key="index" class="add-qualification">
            <v-page-header level="content" class="add-qualification-header" :title="`资质${index + 1}`">
                <v-button slot="extra" type="text" icon="basic_delete_line" remote @click.prevent="deleteItem(index)" />
            </v-page-header>
            <div class="add-qualification-content">
                <div class="add-qualification-item">
                    <div class="add-qualification-desc">
                        资质类型
                    </div>
                    <div class="add-qualification-select">
                        <v-select v-model="item.type" style="width: 100px" :options="qualificationType" />
                        <v-select v-model="item.classify" :options="qualificationArray" max-height="unset" class="select-detail" />
                    </div>
                </div>
                <div class="add-qualification-item">
                    <div class="add-qualification-desc">
                        资质图片
                    </div>
                    <span class="add-qualification-file">
                        <upload :ref="`upload${index}`" :cur="index" :disabled="item.disabled" @uploadComplete="uploadComplete" />
                        <file-view :upload-info="{...item, file_name: item.fileName}" @delete="deleteFile(index)" />
                    </span>
                </div>
            </div>
        </div>
        <v-button kind="primary" type="text" icon="basic_new_line" remote @click.prevent="addQualification">
            添加资质
        </v-button>
    </div>
</template>
<script>
import { qualificationType, qualificationArray } from '../utils/QualificationsData';
import upload from './file-upload.vue';
import fileView from './file-view.vue';
export default {
    components: {
        upload,
        fileView,
    },
    props: {
        eQualification: {
            type: Object,
            default: () => ([]),
        },
    },
    data() {
        return {
            qualificationType,
            qualificationArray,
            selectDetail: 1,
            selectType: 1,
            uploadInfo: [],
        };
    },
    watch: {
        uploadInfo(val) {
            this.$emit('changeQualification', val.map(item => ({
                id: item.id,
                type: item.type,
                classify: item.classify,
                fileName: item.fileName,
            })));
        },
    },
    created() {
        this.uploadInfo = this.eQualification.map(item => ({
            ...item,
            disabled: true,
            fileName: item.file_name,
        }));
    },
    methods: {
        deleteFile(index) {
            this.$set(this.uploadInfo, index, {
                ...this.uploadInfo[index],
                fileName: '',
                disabled: false,
            });
        },
        deleteItem(index) {
            this.uploadInfo.splice(index, 1);
        },
        uploadComplete(res) {
            const { cur } = res;
            this.$set(this.uploadInfo, cur, {
                ...this.uploadInfo[cur],
                fileName: res.name,
                disabled: true,
                id: res.data,
            });
        },
        addQualification() {
            this.uploadInfo.push({
                id: this.uploadInfo.length + 1,
                fileName: '',
                classify: 'key1',
                type: 1,
            });
        },
    },
};
</script>
<style lang="less" scoped>
.add-qualification {
    border-radius: var(--radius-large);
    border: 1px solid var(--color-border-normal);
    background: var(--color-bg-1);
    width: 100%;
    margin-bottom: var(--spacing-loose);
    &-header {
        border-bottom: 1px solid var(--color-divider-normal);
        background: var(--color-bg-contrast);
        padding: var(--spacing-base);
        margin-bottom: var(--spacing-super-tight);
        margin-top: 0;
        border-radius: var(--radius-large);
    }

    &-content {
        padding: 16px;
        box-sizing: border-box;
    }
    &-select {
        display: flex;
        gap: var(--spacing-loose);
        width: 100%;
        .select-detail {
            width: 100%;
        }
    }
    &-file {
        display: flex;
        flex-direction: column;
        flex: 1;
    }

    &-item {
        display: flex;
        align-items: flex-start;
        gap: var(--spacing-base);
        margin-bottom: var(--spacing-base);
        &:last-child {
            margin-top: 24px;
        }
    }

    &-desc {
        width: 90px;
        flex: 0 0 auto;
        color: var(--color-text-caption);
    }
}
</style>
